import { useQuery } from "@tanstack/react-query";

import type { OsAniContextSnapshot } from "@/components/ui/os-layout/buildOsAniContextSnapshot";
import { getClient } from "@/services/api/agentic-v2";
import { getCase } from "@/services/api/case-checking";
import {
  pickSamplePromptHouseholdName,
  resolveSamplePromptHouseholdFetch,
} from "@/services/inAppAgent/samplePromptHouseholdContext";

export function useSamplePromptHouseholdName(
  osContext: OsAniContextSnapshot | null | undefined,
): { householdName: string | null; isLoading: boolean } {
  const fetchPlan = resolveSamplePromptHouseholdFetch(osContext);

  const caseQuery = useQuery({
    queryKey: ["sample-prompt-household", "case", fetchPlan.caseId],
    queryFn: () => getCase(fetchPlan.caseId!),
    enabled: Boolean(fetchPlan.caseId),
    staleTime: 60_000,
  });

  const clientQuery = useQuery({
    queryKey: ["sample-prompt-household", "fa-client", fetchPlan.faClientId],
    queryFn: () => getClient(fetchPlan.faClientId!),
    enabled: Boolean(fetchPlan.faClientId),
    staleTime: 60_000,
  });

  const householdName = pickSamplePromptHouseholdName({
    caseClientName: caseQuery.data?.client_name,
    faClientDisplayName: clientQuery.data?.display_name,
    titleFallback: fetchPlan.titleFallback,
    standupClient: fetchPlan.standupClient,
  });

  const isLoading =
    (Boolean(fetchPlan.caseId) && caseQuery.isLoading && !householdName) ||
    (Boolean(fetchPlan.faClientId) && clientQuery.isLoading && !householdName);

  return { householdName, isLoading };
}
